import { requests } from '@yola/yousersjs';

const configureZendeskSnippet = () => {
  window.zESettings = {
    webWidget: {
      authenticate: {
        chat: {
          jwtFn: (callback) => {
            requests.getZendeskToken().then((jwt) => {
              callback(jwt);
            });
          },
        },
      },
      contactOptions: {
        enabled: true,
      },
      zIndex: 999,
    },
  };
};
export default configureZendeskSnippet;
